<template>
     <v-dialog  persistent  v-model="dialog" width="70%" v-if="assetGroups">      
      <v-card >
        <v-card-title class="grey lighten-3 title" >Configureer kaartweergave<v-spacer></v-spacer><v-btn slot="activator" icon @click="$emit('closeClicked');"><v-icon>close</v-icon></v-btn></v-card-title>        
        <v-card-text  >
            <v-layout column>
                <v-flex sm12 grey lighten-2 v-if="currentFilters.length > 0" px-4 py-4>                    
                    <h5><b>Toegepaste filters:</b></h5>
                    <div v-for="(rule, index) of currentFilters" :key="index">
                        Alle <span class="filter-field">{{ getGroupById(rule.groupId).name }} </span> waarvoor geldt dat 
                        <span class="filter-field">{{ getCustomFieldName(rule.groupId, rule.customFieldId) }}</span> 
                        <span class="filter-field"> {{rule.mode}}</span> <span class="filter-field"> {{rule.value}}{{getCustomFieldTypeByCustomFieldId(rule.customFieldId, rule.groupId)}}</span>                         
                        <i class="pl-4 fas fa-trash-alt" style="cursor: pointer;" @click="removeRule(index)"></i>
                    </div>
                    <div v-for="ug of unfilteredGroups" :key="`UG_${ug.id}`">
                        <div v-if="showNonFiltered">
                            Alle {{ug.name}} worden getoond
                        </div>
                        <div v-else>
                            Alle {{ug.name}} worden verborgen
                        </div>
                    </div>                    
                </v-flex>
                <v-flex sm12 px-2>
                       <v-layout>
                           <v-flex sm px-2>
                                <v-checkbox
                                    v-model="showNonFiltered"
                                    label="Toon groepen waarop geen filter is toegepast"                                
                                ></v-checkbox>
                           </v-flex>
                       </v-layout>
                       <v-layout >
                           <v-flex sm4 px-2>
                               <v-select
                                :items="assetGroups"
                                item-text="name"
                                item-value="id"
                                label="Groep"
                                v-model="selectedGroupId"
                                ></v-select>
                           </v-flex>
                            <v-flex sm4 px-2>
                                <v-select
                                :items="ddGroupDataFields(selectedGroupId)"
                                item-text="text"
                                item-value="value"
                                label="Veld"
                                v-model="selectedCustomFieldId"
                                ></v-select>                               
                           </v-flex>
                           <v-flex sm2 px-2>
                               <v-select
                                :items="compareTypes"                              
                                label="Mode"
                                v-model="selectedCompareType"
                                ></v-select>
                           </v-flex>
                            <v-flex sm4 px-2>
                               <v-text-field
                                    :label="`Waarde (${selectedCustomFieldType})`"
                                    v-model="selectedValue"                                    
                                ></v-text-field>
                           </v-flex>
                            <!-- <v-flex sm2 px-2>
                               <v-select
                                :items="displayTypes"
                             
                                label="Mode"
                                v-model="selectedDisplayMode"
                                ></v-select>
                           </v-flex> -->
                           <v-flex sm1 px-2 style="display: flex; align-items:center; justify-content: center;">
                               <v-btn icon color="light-green white--text" small :disabled="!canBeAdded" @click="addFilter()">
                                   <v-icon>add</v-icon>
                               </v-btn>
                           </v-flex>
                       <!-- <v-flex sm12 md6 lg5>
                           <v-checkbox
                                @click="showDetails(group)"                                
                                label="Toon details"                                
                           ></v-checkbox>
                       </v-flex>
                       <v-flex sm12 md6 lg7>
                           
                       </v-flex> -->
                       </v-layout>
                    <v-layout >
                        <v-flex sm12 style="display: flex; justify-content: flex-end;">
                            <v-btn :disabled="currentFilters.length == 0" @click="applyFilter">Toepassen</v-btn>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-card-text>
      </v-card>
     </v-dialog>
</template>
<script>
import { mapGetters } from 'vuex'
import * as types from "../../store/types"

export default{
    data(){
        return {
            dialog: true,
            mapTypes: [
                {text: 'Standaard', value: 'default'},
                {text: 'Satelliet', value: 'satellite'}
            ], 
            compareTypes: [{text: 'Groter dan', value: '>'}, {text: 'Kleiner dan', value: '<'}, {text: 'Gelijk aan', value: '='}],
            displayTypes: [{text: 'Tonen', value: true},{text: 'Verbergen', value:false}],
            selectedMapType: 'default',
            selectedGroupId: null,
            selectedCustomFieldId: null,
            selectedCompareType: null,
            selectedValue: null,
            selectedCompareType: null,
            // selectedDisplayMode: null,
            currentFilters: [],
            showNonFiltered: true

        }
    },
    computed:{
        ...mapGetters({
            assetGroups: types.ASSET_GROUPS,   
            assetSelectionFilter: types.ASSET_SELECTION_FILTER                 
        }),
        canBeAdded(){
            if(
                this.selectedGroupId && 
                this.selectedCustomFieldId && 
                this.selectedCompareType && 
                this.selectedValue 
                // this.selectedDisplayMode !== null
            ){                
                return true
            }
            return false
        },
        selectedCustomFieldType(){
            let fields = this.selectedGroupDataFields(this.selectedGroupId)

            if(fields && fields.length > 0){
                let field = fields.find((ele) => ele.customField.id == this.selectedCustomFieldId)
                if(field){
                    return field.customField.type.shortName
                }                
            }
            return 'kies veld'
        },
        unfilteredGroups(){
            let ret = []
            for(let group of this.assetGroups){
                let filtered = this.currentFilters.find(e => e.groupId == group.id)
                if(!filtered){
                    ret.push(group)
                }
            }
            return ret
        }        
    },
    methods:{
        removeRule(index){
            this.currentFilters.splice(index,1)
        },
        showDetails(group){
                this.$nextTick(() => {
            })
        },
        selectedGroupDataFields(groupId){
            if(this.assetGroups.length > 0){                
                let selection = this.assetGroups.find((ele) => ele.id == groupId )
                if(selection && selection.dataFields){                                       
                    return selection.dataFields
                }
                
            }
        },
        getCustomFieldName(groupId, customFieldId){
            let fields = this.selectedGroupDataFields(groupId)

            if(fields && fields.length > 0){
                let field = fields.find((ele) => ele.customField.id == customFieldId)

                if(field){
                    return field.customField.name
                }                
            }
            return "onbekend"
        },
        ddGroupDataFields(groupId){
           let items = this.selectedGroupDataFields(groupId)
           
           if(!items)
             return []

           let dd = items.map((ele) => {        
              return {text: ele.customField.name, value: ele.customField.id}
           })
            return dd
        },        
        addFilter(){
            let entry = {
                groupId: this.selectedGroupId,
                customFieldId: this.selectedCustomFieldId,
                mode: this.selectedCompareType,
                value: this.selectedValue,
                // displayMode: this.selectedDisplayMode
            }

            this.currentFilters.push(entry)

            this.clear()
            // this.selectedDisplayMode = null

        },
        getGroupById(id){
            return this.assetGroups.find(e => e.id == id)
        },
        getCustomFieldTypeByCustomFieldId(customFieldId, groupId){
            let fields = this.selectedGroupDataFields(groupId)

            if(fields && fields.length > 0){
                let field = fields.find((ele) => ele.customField.id == customFieldId)
            
                if(field){
                    return field.customField.type.shortName
                }                
            }
        },
        clear(){
            this.selectedGroupId = null
            this.selectedCustomFieldId = null
            this.selectedCompareType = null
            this.selectedValue = null
        },
        applyFilter(){
            this.$store.dispatch(types.ASSET_SELECTION_FILTER, {data: { showUnfiltered: this.showNonFiltered, rules: this.currentFilters }})
            this.$emit('closeClicked')
        }
        // getDataFieldById(dataFields, id){
        //     return this.assetGroups.find(e => e.id == id)
        // }
    },
    mounted(){
        let vm = this
        this.$store.dispatch(types.ASSET_GROUPS,{params: { include: 'dataFields.customField.type'}}).then(() => {

           if(this.assetSelectionFilter){
                this.showNonFiltered = this.assetSelectionFilter.showUnfiltered
                this.currentFilters = this.assetSelectionFilter.rules
           }
        })        
    }
}
</script>
<style scoped>
.group-header{
    font-size: 14px;
    font-weight: 600;
    border-bottom: solid #ccc 1px;
}

.filter-field{
    font-weight: 600;
}
</style>